<template>
  <div class="batch-tool-native-anchor-create-source">
    <div v-if="formKey === 'advertiser_source_name'">
      <el-link v-for="word in formItem.word_list" :key="word" class="mr-10" :underline="false" type="primary" @click="insertWord(`{${word}}`, formItem)">+{{ word }}</el-link>
    </div>
    <!-- 渠道号 -->
    <div v-if="formKey === 'fusion__channel_code_prefix'" class="w-full flex items-center">
      <el-input v-model="formItem.value" v-bind="formItem.props" />
      <el-button :loading="add_channel_config.loading" type="primary" @click="onAddChannel">添加渠道</el-button>
    </div>
    <!-- 已添加的渠道 -->
    <div v-if="formKey === 'fusion__channel_codes'">
      <div v-if="show_channel_preview">
        <el-card :body-style="{ padding: 0 }" shadow="never">
          <div class="font-16 font-weight text-right channel-preview-header">
            渠道数：{{ formItem.value[formItem.tabIndex].list.length }}
          </div>
          <div class="w-full tag-scrollbar-wrapper">
            <channel-preview :form-item="formItem" />
          </div>
        </el-card>
      </div>
    </div>
    <!-- 投放内容 -->
    <div v-if="formKey === 'delivery_content_id'">
      <el-button type="primary" @click="formItem.is_open = true">选择投放内容</el-button>
      <div v-if="Object.keys(formItem.value.result_map || {}).length">
        <div v-for="(item, key) in formItem.value.result_map" :key="key">
          <span class="mr-20">{{ key }}</span>
          <span class="mr-20">{{ getOptionByValue(formItem.value.type_selection, item.type).label || '-' }}</span>
          <span>{{ getOptionByValue(item.options, item.value).label || '-' }}</span>
        </div>
      </div>
      <el-dialog
        title="投放内容配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="800px"
      >
        <delivery-content v-if="formItem.is_open" ref="delivery-content-ref" :form-item="formItem" :init-ops="formItem.initOps" :data-map="getDataMap()" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="deliveryContentConfirm(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getDeliveryContentApi } from '@/api/tool/delivery-content';
import { unique, getArrayIntersection, getArrayDifference } from '@/utils';
import { useGetChannelDetails } from '@/views/fusion/investment/intelligence-create/hooks';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';

export default {
  components: {
    'channel-preview': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/delivery-form/components/channel-preview/index.vue'),
    'delivery-content': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/delivery-form/components/delivery-content/index.vue'),
  },
  props: {
    // 页面配置
    pageConfig: {
      type: Object,
      required: true,
    },
    // 表单配置
    formConfig: {
      type: Object,
      required: true,
    },
    // 表单项键名
    formKey: {
      type: String,
      required: true,
    },
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      add_channel_config: {
        loading: false,
      },
    };
  },
  computed: {
    /** 是否显示添加的渠道列表 */
    show_channel_preview() {
      const { fusion__channel_code } = this.formConfig;
      const { fusion__channel_codes } = fusion__channel_code.children;
      const ret = fusion__channel_codes.value.reduce((pre, cur) => pre.concat(cur.list), []);
      return !!ret.length;
    },
  },
  methods: {
    /**
     * 插入通配符
     * @param word 通配符
     * @param form_item 表单项
     */
    insertWord(word, form_item) {
      const name = form_item.value;
      const match_list = name.match(/{[^}{]*?}/g) || [];
      form_item.value = match_list.includes(word) ? name.replace(word, '') : name.concat(word);
    },
    /**
     * 添加渠道
     * @returns {void}
     */
    onAddChannel() {
      this.add_channel_config.loading = true;
      const { fusion__channel_code, advertiser_id } = this.formConfig;
      if (!advertiser_id.value) {
        this.$message.warning('请先选择广告主账户');
        this.add_channel_config.loading = false;
        return;
      }
      const {
        fusion__channel_code_begin_num,
        fusion__channel_code_count,
        fusion__channel_code_prefix,
        fusion__channel_codes,
      } = fusion__channel_code.children;
      const channel_start = fusion__channel_code_begin_num.value;
      const channel_count = fusion__channel_code_count.value;
      const channel_prefix = fusion__channel_code_prefix.value;
      const channels = [];
      for (let i = channel_start; i <= channel_start + (channel_count - 1); i++) {
        const channel = `${channel_prefix}${i}`;
        channels.push(channel);
      }
      if (channel_prefix.trim() === '') {
        this.$message.warning(fusion__channel_code_prefix.rules.message);
        this.add_channel_config.loading = false;
        return;
      }
      const ret_handler = (data) => data.map(({ alias }) => alias);
      const ret = fusion__channel_codes.value.reduce((pre, cur) => pre.concat(cur.list), []);
      const intersection_list = getArrayIntersection(ret_handler(ret), channels);

      const is_repeat = intersection_list.length > 0;

      if (is_repeat) {
        this.$message.error(`添加失败，${intersection_list.join('、')}重复，不允许重复相同的渠道号`);
        this.add_channel_config.loading = false;
        return;
      }
      useGetChannelDetails(channels).then((res) => {
        const difference_list = getArrayDifference(channels, ret_handler(res));
        const is_diff = difference_list.length > 0;
        if (is_diff) {
          this.$message.error(`添加失败，${difference_list.join('、')}不存在，请检查后重试`);
          return;
        }
        const { tabIndex } = fusion__channel_codes;
        const channels_ret = unique(fusion__channel_codes.value[tabIndex].list.concat(res), 'alias');
        fusion__channel_codes.value[tabIndex].list = channels_ret;
      }).finally(() => {
        this.$nextTick(() => {
          this.$parent.$parent.$parent.$parent.validateField('fusion__channel_code.children.fusion__channel_codes.value');
        });
        this.add_channel_config.loading = false;
      });
    },
    /**
     * 获取数据表
     * @returns {Object}
     */
    getDataMap() {
      const { channel_interface } = this.pageConfig;
      const { delivery_platform_type } = this.formConfig;
      const getDataList = (advertiser_id) => this.getDeliveryContentById(advertiser_id, { delivery_platform_type: delivery_platform_type.value });
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          return {
            'ANDROID': getDataList,
            'IOS': getDataList,
          };
        },
      };
      return strategy[channel_interface]();
    },
    /**
   * 获取投放内容
   * @param {string} advertiser_id 广告主id
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
    async getDeliveryContentById(advertiser_id, filtering = {}) {
      try {
        const { channel_interface } = this.pageConfig;
        const params = {
          channel_interface,
          advertiser_id,
          filtering,
        };
        const ret = await getDeliveryContentApi(params);
        const result = (ret?.list || []).map(({ id, name, ...rest }) => ({ label: `${name}（${id}）`, value: `${id}#${name}`, ...rest }));
        return Promise.resolve(result);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    /**
     * 投放内容配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    deliveryContentConfirm(form_item) {
      const result = this.$refs['delivery-content-ref']?.table_data || [];
      const is_valid = result.every(({ type, target }) => type?.value && target?.[type.value]?.value);
      if (is_valid) {
        result.forEach(({ advertiser_id, type, target }) => {
          Object.assign(form_item.value.result_map, { [advertiser_id]: {
            type: type.value,
            options: target[type.value].options,
            value: target[type.value].value,
          }});
        });
        form_item.is_open = false;
        form_item?.on?.change?.(form_item.value);
        this.$parent.$parent.validateField('delivery_content_id.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
    /**
     * 根据值获取选项
     * @param {Object[]} options 选项
     * @param {number|string} val 值
     * @returns {Object}
     */
    getOptionByValue(options, val) {
      return options.find(({ value }) => value === val) || {};
    },
  },
};
</script>
<style lang="scss">
.batch-tool-native-anchor-create-source {
  .channel-preview-header {
    padding: 8px 20px;
    border-bottom: 1px solid #DCDFE6;
  }
}
</style>
